import { render, staticRenderFns } from "./NavbarWalletSessionConnectedButton.vue?vue&type=template&id=36c7b100"
import script from "./NavbarWalletSessionConnectedButton.vue?vue&type=script&lang=ts"
export * from "./NavbarWalletSessionConnectedButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports